import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=71870bf0&scoped=true&"
import script from "./UserCreate.vue?vue&type=script&lang=js&"
export * from "./UserCreate.vue?vue&type=script&lang=js&"
import style0 from "./UserCreate.vue?vue&type=style&index=0&id=71870bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71870bf0",
  null
  
)

export default component.exports